import PbAjax from '../c-up-pbajax/';
import publicpb from 'c-publicpb';
import profilepb from './index.pb';

let pbajax = new PbAjax();
window.loginTimes = window.loginTimes || 0;

function getUserInfoByIdAndToken(uid, userToken) {
    let businessData = new profilepb.Profile.Get.Request({vuid: uid});
    return new Promise((resolve, reject) => {
        pbajax.do({
                service: 'service',
                api: '/profile/get',
                header: {userToken}
            },
            businessData,
            function (res) {
                let dataWrap = publicpb.Result.decode(res);
                let data;
                if (dataWrap.code === 1) {
                    data = profilepb.Profile.Get.Response.decode(dataWrap.data.value);
                    resolve(data.profile);
                } else {
                    reject(dataWrap.code);
                }
            },
            reject,
            reject
        );
    });
}

function getUserInfo(uid) {
    return new Promise((resolve, reject) => {
        getUserInfoByIdAndToken(uid, UG.getUser().userToken)
            .then(resolve)
            .catch(code => {
                if (code === 8192) {
                    UG.router.replace('/login');
                } else {
                    reject();
                }
            });

    });
}

function isValidUser({uid, userToken}) {
    if (!uid || !userToken) {
        return Promise.resolve(false);
    }
    return new Promise(resolve => {
        getUserInfoByIdAndToken(uid, userToken)
            .then(resolve)
            .catch(() => resolve(false));
    });
}

const Profile = {
    isValidUser,
    getUserInfo,
    getUserInfoByIdAndToken
};

export default Profile;



// WEBPACK FOOTER //
// ./js/component/profile/index.js